import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Modal from "../../../../../../components/Common/Modal/Modal";
import {
  deleteMemberActionHandler,
  deleteSubgroupActionHandler,
} from "../../../../../../store/actions/actionHandlers/adminActionHandler/groupManagementActionHandler";
import { setErrorHandler } from "../../../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../../../utils/errorTypes";
import classes from "./DeleteGroupSubgroup.module.scss";
import { FormattedMessage } from "react-intl";

const DeleteGroupSubgroup = ({
  deleteModal,
  setDeleteModal,
  manageUsersPath,
  location,
  params,
  getUserGroupMemeber,
  selectedData,
  setSelectedTableData,
}) => {
  const [deleteLoader, setDeleteLoader] = useState(false);
  const dispatch = useDispatch();

  const handleSubmit = () => {
    if (manageUsersPath === location?.pathname) {
      setDeleteLoader(true);
      dispatch(
        deleteMemberActionHandler(
          selectedData?.UserGroupId,
          selectedData?.UserId,
          getUserGroupMemeber
        )
      ).then((response) => {
        if (response?.status === 200 && response?.data) {
          setDeleteLoader(false);
          dispatch(
            setErrorHandler(
              errorTypes.SUCCESS,
              `"${
                selectedData?.FirstName + " " + selectedData?.LastName
              }" user successfully removed from the group.`
            )
          );
          getUserGroupMemeber();
          setDeleteModal(!deleteModal);
        } else {
          setDeleteLoader(false);
          dispatch(setErrorHandler(errorTypes.FAIL, "Deletion failed"));
        }
      });
    } else {
      setDeleteLoader(true);
      dispatch(
        deleteSubgroupActionHandler(
          params?.userGroupId,
          selectedData?.UserGroupId,
          getUserGroupMemeber
        )
      ).then((response) => {
        if (response?.status === 200 && response?.data) {
          setDeleteLoader(false);
          dispatch(
            setErrorHandler(
              errorTypes.SUCCESS,
              `"${selectedData?.Name}" Subgroup successfully deleted`
            )
          );
          getUserGroupMemeber();
          setDeleteModal(!deleteModal);
        } else {
          setDeleteLoader(false);
          dispatch(setErrorHandler(errorTypes.FAIL, "Deletion failed"));
        }
      });
    }
    setSelectedTableData([]);
  };

  return (
    <Modal
      handleSubmit={handleSubmit}
      isOpen={deleteModal}
      heading={<FormattedMessage id="USERGROUP_DELETEGRP__HEADERMSG" />}
      toggle={() => setDeleteModal(!deleteModal)}
      buttonLabel1={<FormattedMessage id="OK_TXT" />}
      buttonLabel2={<FormattedMessage id="USERGRP_CANCELBTN_TEXT" />}
      width={"46.2"}
      height={"26.9"}
      loading={deleteLoader}
    >
      <div className={classes.deleteGroupSubgroupModal}>
        <div>
          {location?.pathname === manageUsersPath ? (
            <FormattedMessage id="USERGROUP_DELETEUSER__MSG" />
          ) : (
            <FormattedMessage id="ARE_YOU_SURE_DELETE_TEXT" />
          )}
        </div>
      </div>
    </Modal>
  );
};

export default DeleteGroupSubgroup;
